export default function PreviousIcon() {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polyline
        fill="none"
        strokeWidth="2"
        points="9 6 15 12 9 18"
        transform="matrix(-1 0 0 1 24 0)"
      ></polyline>
    </svg>
  );
}
